<template>
    <v-container class="pa-0">
        <v-card-text>
            <h3 class="mb-4 mt-3">Configuração de agendamento automático de invalidação de consultas de crédito</h3>
            <v-form ref="formConfigDiasAgendamentoAnalise">
                <v-row>
                    <v-col cols="10" md="8">
                        <m-text-field
                                v-input-filter="[$filters.numeric]"
                                :rules="[$rules.required]"
                                v-model="tempo_invalidacao"
                                maxlength="3"
                                label="Quantidade de dias de existência da consulta de crédito para invalidação:"
                                outlined
                                placeholder="Informe a quantidade de dias"
                        />
                    </v-col>
                </v-row>
            </v-form>
            <v-row class="d-flex justify-end">
                <v-col cols="2">
                    <v-btn class="transition" color="primary" rounded @click="salvarParametrizacaoAgendamentoAnalise">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../../plugins/alerts_types'

  export default {
    name: 'ConfigAgendamentoAnaliseInvalida',
    data () {
      return {
        tempo_invalidacao: 0
      }
    },
    async mounted () {
      this.loadTempoInvalidacao()
    },
    methods: {
      loadTempoInvalidacao () {
        this.$http.get('/painel/configuracao/invalidacao_analise')
          .then(response => {
            this.tempo_invalidacao = response.data.tempo_invalidacao
          })
          .catch(() => {
            notification(AlertTypes.ERROR, 'Ocorreu um erro ao buscar a configuração de agendamento automático de invalidação.')
          })
      },
      salvarParametrizacaoAgendamentoAnalise () {
        if (this.$refs.formConfigDiasAgendamentoAnalise.validate()) {
          this.$http.post('/painel/configuracao/invalidacao_analise/salvar', {
            tempo_invalidacao: this.tempo_invalidacao
          })
            .then(response => {
              notification(AlertTypes.SUCCESS, response.data.message)
            })
            .catch(() => {
              notification(AlertTypes.ERROR, 'Ocorreu um erro ao salvar a configuração de agendamento automático de invalidação.')
            })
        }
      }
    }
  }
</script>
